import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import AdminDashboard from "./pages/AdminDashboard";
import Users from "./pages/Users";
import Staff from "./pages/StaffManagement";
import Transactions from "./pages/Transactions";
import ViewUser from "./pages/ViewUser";
import VideoYoutubeList from "./pages/VideoYoutubeList";
import PackageList from "./pages/PackageList";
import TransactionReport from "./pages/TransactionReport";
import WithdrawApprovement from "./pages/WithdrawApprovement";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import CryptoBankCRUD from "./pages/CryptoBankCRUD";
import "./App.css";

function App() {
  const staff = localStorage.getItem("staffData");

  return (
    <Router>
      <Routes>
        {/* Login page — tanpa sidebar/topbar */}
        <Route
          path="/login"
          element={staff ? <Navigate to="/admin-dashboard" replace /> : <Login />}
        />

        {/* Protected routes — tampilkan Sidebar dan Topbar */}
        <Route
          path="/*"
          element={
            staff ? (
              <div className="d-flex">
                {/* Sidebar */}
                <Sidebar />

                {/* Main content */}
                <div
                  className="flex-grow-1 d-flex flex-column bg-light"
                  style={{ minHeight: "100vh" }}
                >
                  {/* Topbar */}
                  <div
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1000,
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <Topbar />
                  </div>

                  {/* Page content */}
                  <div className="p-4" style={{ marginTop: "80px" }}>
                    <Routes>
                      <Route path="/" element={<Navigate to="/admin-dashboard" replace />} />
                      <Route path="/admin-dashboard" element={<AdminDashboard />} />
                      <Route path="/view-user/:username" element={<ViewUser />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/staff" element={<Staff />} />
                      <Route path="/packagelist" element={<PackageList />} />
                      <Route path="/videoyoutubelist" element={<VideoYoutubeList />} />
                      <Route path="/transactions" element={<Transactions />} />
                      <Route path="/reports/withdraw-approvement" element={<WithdrawApprovement />} />
                      <Route path="/reports/transactions" element={<TransactionReport />} />
                      <Route path="/crypto-bank" element={<CryptoBankCRUD />} />
                    </Routes>
                  </div>
                </div>
              </div>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
